import { render, staticRenderFns } from "./carmonthRenior-form.vue?vue&type=template&id=84b8db88&"
import script from "./carmonthRenior-form.vue?vue&type=script&lang=js&"
export * from "./carmonthRenior-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports